export function flattenCourseLessons(modules = []) {
  return modules.flatMap(module => module?.lessons || [])
}

export function canOfferSurveyAfterCourse({ survey, lesson, modules }) {
  if (
    !survey
    || survey.completed
    || survey.placement !== 'after_training'
    || lesson?.type !== 'video'
  ) {
    return false
  }

  const lessons = flattenCourseLessons(modules)
  const lastLesson = lessons[lessons.length - 1]
  if (!lastLesson || `${lastLesson.id}` !== `${lesson?.id}`) return false

  return lessons.every(item => (
    `${item?.id}` === `${lesson?.id}` || !!item?.isCompleted
  ))
}
